export default __webpack_public_path__ + "static/media/images.8116187f.png";